import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const SelectInput = styled.select`
  background-color: none;
  border-radius: 3px;
  height: 3em;
  border: 1px solid #bdbdbd;
  padding-left: 3%;
  font-size: 16px;
  margin-top: 2%;
  width: 100%;

  &:focus {
    outline: none;
    border: 2px solid #549a9a;
  }

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1400px) {
    font-size: 16px;
  }
`;

export const Select = ({ children, ...props }) => {
  return <SelectInput {...props}>{children}</SelectInput>;
};

Select.propTypes = {
  children: PropTypes.node.isRequired,
};
